import fetchJsonp from 'fetch-jsonp';

export default class Zaiko {
  constructor(cont) {
    this.$ = cont;

    // 商品情報
    if(this.$.dataset.shohincd){
      this.shohincd = this.$.dataset.shohincd;
      this.itemJanArr = this.shohincd.split(',');
      this.itemBorder = this.$.dataset.border ? this.$.dataset.border : 10;
    }

    // 景品情報
    if(this.$.querySelector('.js-zaiko-gift')){
      this.giftInput = this.$.querySelector('.js-zaiko-gift');
      this.giftShohincd = this.giftInput.dataset.shohincd;
      this.giftJanArr = this.giftShohincd.split(',');
      this.giftBorder = this.giftInput.dataset.border ? this.giftInput.dataset.border : 10;
    }

    // カートリンク情報
    this.cartParamKey = '&sweb_shohin_cd=';
    if(this.$.querySelector('.js-zaiko-link')){
      this.cartLinkArr = Array.from(this.$.querySelectorAll('.js-zaiko-link'));
    }

    // 在庫API情報
    this.domain = document.domain;
    this.apiPath = "/sw/products/SWFG070740.seam";
    this.janParamKey = '&shohin_cd=';

    this.initialize();

  }

  async initialize() {

    // ドメイン判定&API URLセット
    let domain = '';
    if (this.domain.indexOf('shiseido.co.jp') === -1) {
      domain = 'https://www.shiseido.co.jp';
    }
    let apiURL = domain + this.apiPath;

    this.cartBaseURL = domain + "/sw/products/SWFG070220.seam?actionMethod=/products%2FSWFG070220.xhtml%3AsWFG070220Action.addCartShohin&online_shohin_ctlg_kbn=1&keyword_flg=1";

    // カートリンク設置
    if(this.itemJanArr){
      let cartParam = this.cartParamKey + this.itemJanArr.join(this.cartParamKey);
      let cartURL = this.cartBaseURL + cartParam;
      if(this.cartLinkArr) {
        this.cartLinkArr.forEach(link => {
          link.setAttribute('href',cartURL);
        });
      }
    }

    // 在庫判定文字列初期化
    let zaiko = '';
    let itemZaiko = '';
    let giftZaiko = '';

    // 商品在庫
    if(this.shohincd){
      let itemParam = this.janParamKey + this.itemJanArr.join(this.janParamKey);
      itemParam = '?border=' + this.itemBorder + '&shohin_kbn=1' + itemParam;
      const itemRes = await fetchJsonp(apiURL + itemParam);
      const itemData = await itemRes.json();
      itemZaiko = itemData.map(function(value){
        return value.zaiko_kbn;
      });
      zaiko += ',' + itemZaiko;
    }

    // 景品在庫
    if(this.giftShohincd){
      let giftParam = this.janParamKey + this.giftJanArr.join(this.janParamKey);
      giftParam = '?border=' + this.giftBorder + '&shohin_kbn=2' + giftParam;
      const giftRes = await fetchJsonp(apiURL + giftParam);
      const giftData = await giftRes.json();
      giftZaiko = giftData.map(function(value){
        return value.zaiko_kbn;
      });
      zaiko += ',' + giftZaiko;
    }

    // 該当要素表示
    const displayTarget = Array.from(this.$.querySelectorAll('.zaikokbn' + this.zaikoJudge(zaiko)));
    displayTarget.forEach(elm => {
      elm.style.display = 'block';
    })
    this.$.dataset.zaiko = this.zaikoJudge(zaiko);

  }

  zaikoJudge(str) {
    if(str.indexOf('9') != -1){
      return 9;
    }else if(str.indexOf('0') != -1){
      return 0;
    }else if(str.indexOf('2') != -1){
      return 2;
    }else if(str.indexOf('1') != -1){
      return 1;
    }
  }
}

